export const typeDocReceived = typeDocs => ({
    type: 'TYPE_DOC_RECEIVED',
    payload: typeDocs
});


